import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import { UiContextProvider } from '../../lib/UiContext';
import { useQuery, useUiData } from '../../lib/hooks';
import * as ENTITY_QUERIES from '../../helpers/gqlQueries/ui/context';
import Model, * as Models from '../../helpers/models';
const pageToEntity = {
  programGroup: ['program'],
  district: ['district', 'district_schools', 'community', 'partnert_schools'],
  school: ['school'],
  class: ['class'],
  user: ['student', 'user']
};
const setQueryParams = (router, newParams) => {
  const newQuery = {
    ...router.query
  };
  Object.keys(newParams).forEach(k => {
    if (newParams[k]) {
      newQuery[k] = newParams[k];
    } else {
      delete newQuery[k];
    }
  });
  router.push({
    pathname: router.pathname,
    query: newQuery
  });
};
const UiContextController = ({
  children
}) => {
  const router = useRouter();
  const {
    isPending,
    errors,
    data: {
      semesters
    }
  } = useUiData(['semesters']);
  const entityType = Object.keys(pageToEntity).find(k => pageToEntity[k].includes(router.pathname.split('/')[2]));
  const entityQuery = Object.keys(ENTITY_QUERIES).reduce((qData, key) => {
    const shouldBeKey = `UI_GET_${entityType}_CONTEXT`.toUpperCase() === key;
    const q = useQuery(ENTITY_QUERIES[key], {
      variables: {
        [`${entityType}Id`]: router.query.id
      },
      skip: !(shouldBeKey && router.query.id)
    });
    return shouldBeKey ? q : qData;
  }, {});
  const uiContext = {};
  Object.defineProperty(uiContext, 'loading', {
    value: isPending || entityQuery.loading
  });
  Object.defineProperty(uiContext, 'error', {
    value: errors[0] || entityQuery.error
  });
  Object.defineProperty(uiContext, 'entity', {
    value: entityQuery.data?.[`${entityType}ById`]
  });
  if (!uiContext.loading && !uiContext.error) {
    const entityModel = uiContext.entity ? new Models[uiContext.entity.__typename](uiContext.entity, {
      classID: router.query.classId,
      semesters: semesters
    }) : new Model({});
    const dateSpan = {};
    Object.defineProperty(dateSpan, 'from', {
      get: () => {
        const t = dayjs(router.query.startDate, 'YYYY-MM-DD');
        return t.isValid() ? t : entityModel?.defaultDateRange.from;
      }
    });
    Object.defineProperty(dateSpan, 'to', {
      get: () => {
        const t = dayjs(router.query.endDate, 'YYYY-MM-DD');
        return t.isValid() ? t : entityModel?.defaultDateRange.to;
      }
    });
    Object.defineProperty(uiContext, 'dateSpan', {
      get: () => dateSpan,
      set: val => {
        const v = (({
          from,
          to
        }) => ({
          startDate: dayjs(from, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          endDate: dayjs(to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }))(val);
        setQueryParams(router, v);
      }
    });
    Object.defineProperty(uiContext, 'possibleDateSpan', {
      value: entityModel?.possibleDateRange
    });
    Object.defineProperty(uiContext, 'quickDateSpans', {
      value: entityModel?.quickDateRanges
    });
  }
  return <UiContextProvider value={Object.seal(uiContext)} data-sentry-element="UiContextProvider" data-sentry-component="UiContextController" data-sentry-source-file="UiContextController.jsx">{children}</UiContextProvider>;
};
export default UiContextController;